import { HttpReqService } from '@api/services/http-req/http-req.service';
/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */

import { OutputAdapterService } from '@api/services/output-adapter/output-adapter.service';
import { InputAdapterService } from '@api/services/input-adapter/input-adapter.service';
import { ApiService } from '@api/services/api/api.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import {
  LabelItemDTO,
  ChecklistDTO,
  PositionDTO,
  WizardDTO,
  SurveyDTO,
  DomainItemDTO,
  FormDTO,
  UserDataDTO,
  OcrCheckDTO
} from '../../models';
import { environment } from '@environments/environment';

export interface DbUserDataDTO extends UserDataDTO {
  code: string;
}

export interface DbDomainItemDTO extends DomainItemDTO {
  code: string;
}

export interface DbWizardDTO extends WizardDTO {
  operation: string;
}

export interface DBStructure {
  userData?: DbUserDataDTO[];
  labels?: LabelItemDTO[];
  domains?: DbDomainItemDTO[];
  positions?: PositionDTO[];
  wizards?: DbWizardDTO[];
  surveys?: SurveyDTO[];
  forms?: FormDTO[];
  checklists?: ChecklistDTO[];
  scans?: OcrCheckDTO[];
}

@Injectable({
  providedIn: 'root'
})
export class ApiDemoService extends ApiService {
  protected db: DBStructure;

  constructor(
    protected http: HttpClient,
    protected outputAdapter: OutputAdapterService,
    protected inputAdapter: InputAdapterService,
    protected httpReqService: HttpReqService
  ) {
    super(http, outputAdapter, inputAdapter, httpReqService);
  }

  protected loadDB(): Observable<DBStructure> {
    if (!!this.db && Object.keys(this.db).length > 0) {
      return of(this.db);
    }

    return this.getDB().pipe(
      map(db => {
        this.db = db;
        this.syncStorageDB();

        return db;
      })
    );
  }

  protected getDB(): Observable<DBStructure> {
    const demoDB = this.getStoregeDB();

    if (!!demoDB) {
      return of<DBStructure>(JSON.parse(demoDB));
    } else {
      return this.http.get(environment.demoDBUrl);
    }
  }

  protected syncStorageDB(): void {
    if (!this.db) {
      return;
    }

    this.setStoregeDB(JSON.stringify(this.db));
  }

  protected getData<T>(data: T, delayTime: number = 500): Observable<T> {
    let output = null;

    try {
      output = JSON.parse(JSON.stringify(data));
    } catch (_) {}

    return of(output).pipe(delay(delayTime));
  }

  private getStoregeDB(): string {
    return sessionStorage.getItem('demoDB');
  }

  private setStoregeDB(data: string): void {
    sessionStorage.setItem('demoDB', data);
  }
}
